<template>
  <div class="ctt" id="Contact">
    <!-- <p class="title" name="Contact">Contact Us</p> -->
    <div class="main">
      <el-row :gutter="100">
        <el-col class="ctt-left" :span="9" :xs="24">
          <img width="100%" src="@images/contact_1.png" alt="" />
        </el-col>
        <el-col class="ctt-right" :span="15" :xs="24">
          <h3>联系方式</h3>
          <p>非常欢迎各级广告主、媒体和我们进行交流和合作，请和我们的销售团队联系，或者通过下面的邮箱和我们联系，我们会安排拜访和面谈。</p>
          <div class="ctt-email"><img src="@images/contact_2.png" alt="" /><span>support@alphatenbyte.com</span></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "Contact",
  data: function () {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.ctt {
  background: #ffffff;
  position: relative;
  min-height: px2rem(605);
  box-shadow: $section-box-shadow;
  padding: 1px 0 px2rem(40) 0;
  background: url("~@images/main-bg.png") no-repeat center;
  background-size: 100% 100%;
  background-position: center top;
  .main {
    max-width: px2rem(900);
    .el-row {
      margin-top: px2rem(110);
      .ctt-left {
        img {
          display: inline-block;
          margin-top: px2rem(40);
        }
      }
      .ctt-right {
        color: #ffffff;
        h3 {
          font-size: px2rem(30);
        }
        p {
          font-size: px2rem(19);
          text-align: left;
          line-height: 1.4;
        }
        .ctt-email {
          line-height: px2rem(80);
          text-align: left;
          img {
            height: px2rem(50);
            vertical-align: middle;
          }
          span {
            font-size: px2rem(19);
            height: px2rem(80);
            vertical-align: middle;
            margin-left: px2rem(20);
          }
        }
      }
    }
  }
}
</style>